import { useTheme, useMediaQuery } from '@mui/material';
import DesktopNavigation from './views/DesktopNavigation';
import MobileNavigation from './views/MobileNavigation';
import { NavigationLogicResult } from './types';
import ResponsiveDesktopNavigation from './views/ResponsiveDesktopNavigation';
import { FeatureFlags } from '../../../flags';
import { useFeatureFlags } from 'src/contexts/FeatureFlagsContext';

const EditNavigation = ({
  navigationLogic,
}: {
  navigationLogic: NavigationLogicResult;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { hasFeature } = useFeatureFlags();
  const hasSidepanlRedesign = hasFeature(
    FeatureFlags.NGW_EDIT_SIDEPANEL_REDESIGN,
  );

  const originalStyles = {
    color: 'grey.700',
    height: '50px',
    px: 1.5,
    backgroundColor: 'grey.50',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderTop: '1px solid',
    borderColor: 'grey.300',
    borderRadius: 0,
    textTransform: 'capitalize',
  };

  const redesignStyles = {
    ...originalStyles,
    color: 'secondary.medium',
    backgroundColor: 'background.paper',
    position: 'unset',
    paddingY: 5,
    paddingX: 3,
    borderTop: 0,
    marginTop: 0,
  };

  return isMobile ? (
    <MobileNavigation
      {...navigationLogic}
      setDefaultsStyles={hasSidepanlRedesign ? redesignStyles : originalStyles}
    />
  ) : hasSidepanlRedesign ? (
    <ResponsiveDesktopNavigation
      {...navigationLogic}
      setDefaultsStyles={redesignStyles}
    />
  ) : (
    <DesktopNavigation
      {...navigationLogic}
      setDefaultsStyles={originalStyles}
    />
  );
};

export default EditNavigation;
